import {
	getItem as getStorageItem,
	setItem as setStorageItem
} from '../storage'

const KEY = 'PERSIST_NPS'

export const setPersistNps = async (value: boolean | null) => {
	setStorageItem(KEY, JSON.stringify(value))
}

export const getPersistNps = async (): Promise<boolean | undefined | null> => {
	const newPersistNp = await getStorageItem(KEY)

	if (!newPersistNp) {
		return
	}

	return JSON.parse(newPersistNp)
}
